// extracted by css-extract-rspack-plugin
export default {"card":"G8Ve3lGx2r0D9V_r","target":"iHB78kQusP_aTRov","body":"Ri2rS5Nvi1cxjPfa","group":"DBg96BJUdlkeluO5","actions":"WVNLEnI4hH0SwuTm"};